import React, { Component } from 'react'
import arrowRightWhite from '../../assets/pictos/arrow-right-white.svg'
import styles from './styles';
import { css } from 'aphrodite';

class Button extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    return (
      <div>
        <button
          type="submit"
          className={css(styles.buttonStyle)}
          >

            <span className={css(styles.buttonText)}>Afficher les résultats</span>
            <img className={css(styles.buttonImage)} src={ '/themes/custom/aew/simulator/' + arrowRightWhite } alt="flèche droite" />
        </button>
      </div>
    )

  }
}

export default Button;
